export default "__VITE_ASSET__CnGr5I7g__"